import { Component } from '@angular/core';
import { DeduplikacijaMjestoAttributeStateService } from '@app/shared/services/mjesto-selection-provider.service';
import { CommonFormComponent, DynamicFormService } from '@ntap/common';
import { AttributeStateService } from '@ntap/core';

@Component({
  selector: 'app-deduplikacija-mjesto-dropdown',
  template:
    '<ntap-prime-inputdropdown [inputParam]="inputParam"></ntap-prime-inputdropdown>',
  providers: [
    {
      provide: AttributeStateService,
      useExisting: DeduplikacijaMjestoAttributeStateService
    }
  ]
})
export class DeduplikacijaMjestoDropdownComponent extends CommonFormComponent {
  constructor(
    protected override formService: DynamicFormService,
    attributeStateService: DeduplikacijaMjestoAttributeStateService
  ) {
    super(formService, attributeStateService);
    this.log('dropdown constructor');
  }
}
